class SmartSocket {
	//smart socket will try once to reconnect it's websocket if it disconnects
	//if we we're sending a message smartsocket will try to re-connect and THEN resend the message once

	socket = null;
	onMessage = null;
	validReadyState = 1;
	attemptedReconnect = false;
	timeoutTime = 3000;
	startingTimeoutTime = 3000;
	maxTimeoutTime = 10 * 1000;
	url = "";
	closed = false;
	messageToSend = "";

	totalRetries = 0;
	maxRetries = 3;
	

	constructor(url,onMessage) {

		this.url = url;
		this.onMessage = onMessage;

		this.createSocket();

	}

	send(data){


		if(this.socket.readyState==this.validReadyState){
			//socket is ready send the message
			this.socket.send(data);
		}else {
			//something is wrong. we are going to retry once and then we are going to send the message if successful
			this.messageToSend = data;
			this.createSocket();

		}
		
	}

	createSocket(){


		this.socket = new WebSocket(this.url);
		this.socket.onmessage = this.onMessage;

		this.socket.onopen = ()=>{
			this.totalRetries = 0;
			this.timeoutTime = this.startingTimeoutTime;
			setTimeout(()=>{
				this.checkSocket();
			},this.timeoutTime);

			if(this.messageToSend!=""){
				//it's possible we are re-opening and had a message to send
				//send the message and then clear out our message variable
				this.socket.send(this.messageToSend);
				this.messageToSend = "";
			}

		};
		
	}

	checkSocket(){

		if(this.closed){
			return;
		}


		if(this.socket.readyState==this.validReadyState){
			//we have a valid websocket
			//check again after a bit longer of timeout
			this.timeoutTime = this.timeoutTime < this.maxTimeoutTime ? this.timeoutTime * 2 : this.maxTimeoutTime;

			setTimeout(()=>{
				this.checkSocket();
			},this.timeoutTime);


		}else if(this.totalRetries<this.maxRetries){
			//the socket isn't connected and we haven't attempted to reconnect yet

			this.totalRetries++;
			this.createSocket();
			this.timeoutTime = this.startingTimeoutTime;

			setTimeout(()=>{
				this.checkSocket();
			},this.timeoutTime);


		} else {
			//we have already attempted to reconnect and failed so we're done
			this.closed = true;

		}

	}

	close(){
		this.socket.close();
		this.closed = true;
	}


}

export default SmartSocket;